declare global {
    interface Window {
        __RUNTIME_CONFIG__?: {
            REACT_APP_BACKEND_BASE_URL: string;
            REACT_APP_MSAL_CLIENT_ID: string;
            REACT_APP_MSAL_SCOPE: string;
        };
    }
}

export const msalConfig = {
    auth: {
        clientId: (window.__RUNTIME_CONFIG__?.REACT_APP_MSAL_CLIENT_ID) || process.env.REACT_APP_MSAL_CLIENT_ID || '746fc26c-d13d-4eae-9421-51b78ae51dbb',
        authority: process.env.REACT_APP_MSAL_AUTHORITY || 'https://login.microsoftonline.com/771c9c47-7f24-44dc-958e-34f8713a8394',
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin
    },
    cache: {
        cacheLocation: process.env.REACT_APP_MSAL_CACHE_LOCATION || "localStorage",
        storeAuthStateInCookie: process.env.REACT_APP_MSAL_STORE_AUTH_STATE_IN_COOKIE === "true" ? true : false,
    },
    baseUrl: (window.__RUNTIME_CONFIG__?.REACT_APP_BACKEND_BASE_URL) || process.env.REACT_APP_BACKEND_BASE_URL || '',              
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0:
                        console.error(message);
                        break;
                    case 1:
                        console.warn(message);
                        break;
                    case 2:
                        console.info(message);
                        break;
                    case 3:
                        console.debug(message);
                        break;
                }
            },
            piiLoggingEnabled: false,
        },
    },
};

export const loginRequest = {
    scopes: [        
        (window.__RUNTIME_CONFIG__?.REACT_APP_MSAL_SCOPE) || process.env.REACT_APP_MSAL_SCOPE || "api://f7631b65-746d-4740-a9cb-f0bcfb232b0b/Backend.call"
    ]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// Debug logging
console.log("Runtime Config:", window.__RUNTIME_CONFIG__);
console.log("REACT_APP_MSAL_SCOPE URL:", (window.__RUNTIME_CONFIG__?.REACT_APP_MSAL_SCOPE) || process.env.REACT_APP_MSAL_SCOPE || '');
console.log("Environment MSAL Client ID:", process.env.REACT_APP_MSAL_CLIENT_ID);
console.log("Final Backend Base URL:", (window.__RUNTIME_CONFIG__?.REACT_APP_BACKEND_BASE_URL) || process.env.REACT_APP_BACKEND_BASE_URL || '');
console.log("Final MSAL Client ID:", (window.__RUNTIME_CONFIG__?.REACT_APP_MSAL_CLIENT_ID) || process.env.REACT_APP_MSAL_CLIENT_ID || '746fc26c-d13d-4eae-9421-51b78ae51dbb');
